import React from "react";
import { Container } from "react-bootstrap";
import "./style.css";
import styled from "styled-components";
import PropTypes from "prop-types";

export const BtnWrapCover = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;
`;

export const Button = styled.button`
  padding: 20px 60px;
  font-size: 18px;
  font-weight: bold;
  border: none;
  border-radius: 30px;
  background-color: #18e68e;
  color: #000;
  cursor: pointer;
  transition: transform 0.3s ease, background-color 0.3s ease;

  &:hover {
    background-color: rgb(255, 255, 255);
  }
`;

const AboutSection = ({ headline, description }) => {
  return (
    <div className="discover">
      <Container>
        <div className="content">
          <h1>{headline}</h1>
          <p>{description}</p>
        </div>
      </Container>
    </div>
  );
};
AboutSection.propTypes = {
  headline: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
export default AboutSection;
